module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURQBQ2EdwTABS2QBR2gBQ1wBS2gBR2QBR2ABS2QBR2QBS2QBS2XaHvIcAAAALdFJOUyEA379AoZBYc8/vcfbpBQAAAKNJREFUCNc9zjEKwjAUBuCXgs75k1LUqZlEuhjXTt7AvZPg5g3sokcQF+/gljZWzOXMa6j/ED4evLyf8A/xox/XiSqEA1PeoN61E5HZB6rPqzKyMZHIOpAMginDngoPJpoj6SGxvZP6Wqx66MqQchbnEvplaDlgETfRWio6yCfGtZxHiJ8JQl0yM8+HnVBGjodl5S/rVAezELNNfee7zWmqnvIDLbkp1/dZY+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/prow3.png
// module id = Kozd
// module chunks = 1